module.exports = __webpack_public_path__ + "static/media/CARDS.21149cd4.svg";